import React, { Children } from 'react';
import { motion } from 'framer-motion';
const stagger = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12
    }
  }
};
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};
export function TitleSlide() {
  return <motion.div className="w-full h-full flex flex-col items-center justify-center relative px-12 py-10" variants={stagger} initial="hidden" animate="visible" data-id="element-373">
      {/* Decorative circuit lines */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-374">
        <svg className="absolute top-0 left-0 w-full h-full opacity-[0.07]" xmlns="http://www.w3.org/2000/svg" data-id="element-375">
          <line x1="10%" y1="0" x2="10%" y2="100%" stroke="#00d4ff" strokeWidth="0.5" data-id="element-376" />
          <line x1="90%" y1="0" x2="90%" y2="100%" stroke="#00d4ff" strokeWidth="0.5" data-id="element-377" />
          <line x1="0" y1="20%" x2="100%" y2="20%" stroke="#00d4ff" strokeWidth="0.5" data-id="element-378" />
          <line x1="0" y1="80%" x2="100%" y2="80%" stroke="#00d4ff" strokeWidth="0.5" data-id="element-379" />
          <circle cx="10%" cy="20%" r="3" fill="#00d4ff" data-id="element-380" />
          <circle cx="90%" cy="20%" r="3" fill="#00d4ff" data-id="element-381" />
          <circle cx="10%" cy="80%" r="3" fill="#00d4ff" data-id="element-382" />
          <circle cx="90%" cy="80%" r="3" fill="#00d4ff" data-id="element-383" />
        </svg>
      </div>

      {/* FPGA-inspired logo mark */}
      <motion.div variants={fadeUp} className="mb-8" data-id="element-384">
        <div className="relative w-20 h-20 mx-auto" data-id="element-385">
          <div className="absolute inset-0 border-2 border-[#00d4ff] rounded-lg rotate-45 opacity-60" data-id="element-386" />
          <div className="absolute inset-2 border border-[#00d4ff] rounded-md rotate-45 opacity-40" data-id="element-387" />
          <div className="absolute inset-4 border border-[#00d4ff] rounded-sm rotate-45 opacity-20" data-id="element-388" />
          <div className="absolute inset-0 flex items-center justify-center" data-id="element-389">
            <div className="w-2 h-2 bg-[#00d4ff] rounded-full shadow-[0_0_12px_rgba(0,212,255,0.6)]" data-id="element-390" />
          </div>
        </div>
      </motion.div>

      {/* Company name */}
      <motion.h1 variants={fadeUp} className="text-6xl md:text-7xl font-black tracking-tight text-white mb-6" data-id="element-391">
        Open<span className="text-[#00d4ff]" data-id="element-392">FPGA</span>
      </motion.h1>

      {/* One-liner */}
      <motion.p variants={fadeUp} className="text-2xl md:text-3xl text-[#8899aa] max-w-3xl text-center leading-relaxed font-light" data-id="element-393">
        The software inference gateway that moves LLM workloads onto FPGAs for
        more tokens per watt.
      </motion.p>

      {/* Divider */}
      <motion.div variants={fadeUp} className="w-24 h-[2px] bg-gradient-to-r from-transparent via-[#00d4ff] to-transparent my-10 opacity-50" data-id="element-394" />

      {/* Founders */}
      <motion.div variants={fadeUp} className="text-center space-y-1" data-id="element-395">
        <p className="text-lg text-[#8899aa] tracking-widest uppercase font-medium" data-id="element-396">
          Founded by
        </p>
        <p className="text-xl text-white/80 font-medium" data-id="element-397">
          Nour · Orion · Faris
        </p>
        <p className="text-lg text-[#8899aa] mt-2" data-id="element-398">founders@openfpga.ai</p>
      </motion.div>

      {/* Seed badge */}
      <motion.div variants={fadeUp} className="absolute bottom-8 right-12 px-4 py-1.5 border border-[rgba(255,255,255,0.1)] rounded-full text-base text-[#8899aa] tracking-wider uppercase" data-id="element-399">
        Pre-Seed Round · 2026
      </motion.div>
    </motion.div>;
}